import * as React from 'react'
import { TripStatuses } from '../../../constants/trip-statuses'
import { ITripStatusesObj, IActiveTripResponseV2 } from '../../../types'
import UIMessages from '../../../utils/ui-messages'

export interface IStatusTripProps {
  displayText?: string
  status: ITripStatusesObj
  currentTrip: IActiveTripResponseV2
}

const ErrorStatuses = [TripStatuses.BOOKING_FAILED, TripStatuses.INTEGRATION_FAILED]
const AlertStatuses = [
  TripStatuses.CANCELLED,
  TripStatuses.REJECTED,
  TripStatuses.DRIVER_CANCELLED,
  TripStatuses.CANCEL_BILLABLE,
  TripStatuses.NO_SHOW_RIDER
]

const StatusTrip = (props: IStatusTripProps) => {
  const { displayText, status, currentTrip } = props
  const title = displayText ? displayText : UIMessages.tripStatusMap[status.status]
  const currentTripStatus = currentTrip.status
    ? currentTrip.status.find(item => item.statusId === currentTrip.lastStatusId)
    : {
        status: currentTrip.lastStatus,
        createdAt: currentTrip.lastStatusAt,
        comment: ''
      }
  const comment = currentTripStatus ? currentTripStatus.comment : null
  //Added mt1
  if (AlertStatuses.includes(status.status)) {
    return (
      <div className='center bg-light-orange col-12 py05 bt-orange'>
        <p className='font-white mt1 mb1 bold uppercase'>{title}</p>
        {comment && <p className='font-white bold'>Reason: {comment}</p>}
      </div>
    )
  }

  if (ErrorStatuses.includes(status.status)) {
    return (
      <div className='p1 center bg-light-red py05 bold border-red'>
        <p className='font-white mt1 '>{title}</p>
      </div>
    )
  }

  return (
    <div className='center bg-blue py05 bold border-blue'>
      <p className='font-white mt1 mb1 uppercase'>{title}</p>
    </div>
  )
  //Added mt1
}

export default StatusTrip



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/StatusTrip.tsx